/*
 * File: CustomChip.tsx
 * Project: a-a
 * File Created: Thursday, 14th November 2024 9:06:01 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 25th July 2025 8:13:36 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Box, Chip, Skeleton, SxProps, Typography, useTheme } from '@mui/material';
import React from 'react';
import CustomCard from '../CustomCard/CustomCard';
import zeplinColor from '../../../theme/Color';
import styles from './CustomChip.module.css';
const CustomChip = ({
  text,
  value,
  handleClick,
  active,
  count,
  height,
  loading,
  variant,
  style,
}: {
  text: string;
  value: string;
  count?: number;
  handleClick: (e: string) => void;
  active?: string[];
  height?: string;
  loading?: boolean;
  variant?: string;
  style?: SxProps;
}) => {
  const theme = useTheme();
  // console.log(style);
  return (
    <Chip
      onClick={() => handleClick(value)}
      label={
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'space-between',
            gap: '8px',
            alignItems: 'center',
          }}
        >
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                width: '2rem',
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography
              variant={variant ? 'responsiveBody3' : 'body3'}
              color={active?.includes(value) ? zeplinColor.Neutral1 : zeplinColor.BasicBlack}
            >
              {text}
            </Typography>
          )}
          {count ? (
            <CustomCard
              styles={{
                borderRadius: '60px',
                width: '23px',
                height: '22px',
                padding: '12px',
                backgroundColor: zeplinColor.Neutral1,
                border: `1px solid ${zeplinColor.Neutral5}`,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: 'rgba(0, 0, 0, 0.15)',
              }}
            >
              <Typography
                variant={variant ? 'responsiveLabel1' : 'label1'}
                color={zeplinColor.Brand1}
              >
                {count}
              </Typography>
            </CustomCard>
          ) : (
            ''
          )}
        </Box>
      }
      className={styles['custom-chip']}
      sx={{
        height: height ? height : { xs: '30px', xl: '40px' },
        ...(height && { borderRadius: '50px' }),
        ...(style ? style : {}),
        cursor: 'pointer',
        backgroundColor: active?.includes(value) ? zeplinColor.BasicBlack : zeplinColor.Neutral3,
        '&:hover': {
          backgroundColor: active?.includes(value) ? zeplinColor.BasicBlack : zeplinColor.Neutral4,
        },
        '& .MuiChip-label': {
          paddingLeft: '12px',
          paddingRight: '8px',
        },
      }}
    />
  );
};

export default CustomChip;
